(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Lookups = window.Dashboard.Models.Lookups || {};

    /**
     * Lookup for campaign actions
     * @constructor
     */
    window.Dashboard.Models.Lookups.CampaignActions = {
        Communication: "Communication",
        MenuScript: "Menu Script",
        Voucher: "Voucher"
    };
})();
